import { Injectable, signal } from '@angular/core';

export interface Toast {
  id: number;
  message: string;
  type: 'error' | 'success' | 'info';
  duration?: number;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private nextId = 1;
  toasts = signal<Toast[]>([]);

  show(message: string, type: 'error' | 'success' | 'info' = 'info', duration = 4000) {
    const id = this.nextId++;
    const toast: Toast = { id, message, type, duration };

    this.toasts.update(current => [...current, toast]);

    if (duration > 0) {
      setTimeout(() => {
        this.remove(id);
      }, duration);
    }
  }

  error(message: string, duration = 4500) {
    this.show(message, 'error', duration);
  }

  success(message: string, duration = 3500) {
    this.show(message, 'success', duration);
  }

  info(message: string, duration = 3500) {
    this.show(message, 'info', duration);
  }

  remove(id: number) {
    this.toasts.update(current => current.filter(t => t.id !== id));
  }
}
